export default "__VITE_ASSET__1ad13c04__"